// TODO move this to pubsub library
export const PEER_JOINED = "peer joined";
export const PEER_LEFT = "peer left";
export const SUBCRIBED = "subscribed";
export const MESSAGE = "message";
